<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">耗材领用申请</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="[1]" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="耗材名称">
          <el-input v-model="formInline.product_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择">
            <el-option v-for="item in $store.state.reviewStatus2" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请日期">
          <el-date-picker v-model="formInline.date" type="daterange" range-separator="至" value-format="yyyy-MM-dd"
            clearable start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd(() => {
            getConsumes()
          })">新增申请</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="downloadFile">下载实训耗材采购申请模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile" @refresh="handleQuery" :action="action" :params="params"
            :btnTitle="btnTitle"></Importt>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column fixed prop="product_name" label="耗材名称" min-width="150">
        </custom-table-column>
        <custom-table-column fixed prop="product_number" label="耗材编号" min-width="150">
        </custom-table-column>
        <custom-table-column prop="status" label="状态" width="80" label-class-name="reviewStatus2"
          :formatter="format_arr">
        </custom-table-column>
        <custom-table-column prop="apply_quantity" label="领用数量" width="80">
        </custom-table-column>
        <custom-table-column prop="unit" label="单位" width="100">
        </custom-table-column>
        <custom-table-column prop="syyt" label="使用用途" width="100">
        </custom-table-column>
        <custom-table-column prop="syzs" label="使用周数" width="80">
        </custom-table-column>
        <custom-table-column prop="lyr" label="领用人" width="80">
        </custom-table-column>
        <custom-table-column prop="bj" label="班级" width="120">
        </custom-table-column>
        <custom-table-column prop="kcmc" label="课程" width="140">
        </custom-table-column>
        <custom-table-column prop="rs" label="人数" width="80">
        </custom-table-column>
        <custom-table-column prop="apply_reason" label="申请理由" min-width="200px">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" width="180">
        </custom-table-column>
        <!-- <custom-table-column prop="apply_structure_2" label="专业" width="180">
        </custom-table-column> -->
        <custom-table-column prop="approver_name" label="审批人" width="100px">
        </custom-table-column>
        <custom-table-column prop="approve_remark" label="说明原因" width="160px">
        </custom-table-column>
        <custom-table-column prop="approve_date" label="审批时间" width="160px">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleEditNew(scope.row, ['id'], () => handleEditInit(scope.row))"
               type="text" v-if="scope.row.status == 1"  size="small">编辑</el-button>
            <el-button v-if="scope.row.status != 2" @click="handleDelet(scope.row.id)" type="text"
              size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="756px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
        <el-form-item label="耗材" prop="consumed_product_id">
          <el-select v-model="ruleForm.consumed_product_id" clearable filterable :placeholder="`请选择`"
            style="width: 216px;" @change="handleComsumeChange">
            <el-option v-for="item in consumes" :key="item.id" :label="item.name" :value="item.id"
              :disabled="item.remainder_quantity * 1 == 0">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">编号：{{ item.number }}</p>
              <p v-if="item.remainder_quantity" class="el-option-tips">当前库存：{{ item.remainder_quantity }}</p>
              <p v-if="item.price" class="el-option-tips">价格：{{ item.price }}</p>
              <p v-if="item.unit" class="el-option-tips">单位：{{ item.unit }}</p>
              <p v-if="item.size" class="el-option-tips">规格：{{ item.size }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="领用数量" prop="apply_quantity">
          <el-input-number v-model="ruleForm.apply_quantity" :min="0" :max="kc*1" placeholder="请输入"
            style="width:216px;"></el-input-number>
        </el-form-item>
        <el-form-item label="使用用途" prop="syyt">
          <el-select v-model="ruleForm.syyt" style="width:216px;" filterable clearable placeholder="请先选择使用用途"
            @change="handleUseChange">
            <el-option value="教学" label="教学"></el-option>
            <el-option value="竞赛" label="竞赛"></el-option>
            <el-option value="其他" label="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用周数" prop="syzs">
          <el-input-number v-model="ruleForm.syzs" :min="0" placeholder="请输入" style="width:216px;"></el-input-number>
        </el-form-item>
        <el-form-item label="班级" prop="bj">
          <OrganDialog ref="organDia" @getSelect="getSelect" :level="[1,2,3]" @handleOrganQuery="handleOrganQueryNeed">
          </OrganDialog>
          <!-- <el-input v-model="ruleForm.bj" clearable placeholder="请输入" style="width:216px;"></el-input> -->
          <el-input v-model="ruleForm.bj" placeholder="请选择班级"  style="width:216px;" @focus="dialogOpen" @clear="handeleClear" clearable></el-input>
        </el-form-item>
        <el-form-item label="领用人" prop="lyr">
          <el-input v-model="ruleForm.lyr" clearable placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item :label="`所属课程`" prop="kcmc" v-if="ruleForm.syyt == '教学'">
          <el-select v-model="ruleForm.kc_id" clearable filterable remote :remote-method="getCourseList"
            :loading="loading1" :placeholder="`请输入搜索`" style="width: 216px;" @change="handleCourseChange">
            <el-option v-for="item in courseList" :key="item.id" :label="item.course_name" :value="item.id">
              <p>{{ item.course_name }}（{{ item.course_no }}）</p>
              <p v-if="item.training_name" class="el-option-tips">所属实训室：{{ item.training_name }}</p>
              <p v-if="item.class_teacher" class="el-option-tips">任课老师：{{ item.class_teacher }}</p>
              <p v-if="item.term" class="el-option-tips">学年学期：{{ item.xn }} {{ item.term }}</p>
              <p v-if="item.structure_1" class="el-option-tips">组织结构：{{ item.structure_1 }}-{{ item.structure_2
              }}-{{ item.class_name }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人 数" prop="rs" v-if="ruleForm.syyt == '教学'">
          <el-input-number v-model="ruleForm.rs" placeholder="请输入人数" style="width:216px;"></el-input-number>
        </el-form-item>
        <el-form-item label="申请理由" prop="apply_reason">
          <el-input type="textarea" v-model="ruleForm.apply_reason" placeholder="请输入" style="width:562px;" :rows="4">
          </el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinImport, mixinValidate, mixinFormatter],
  data() {
    return {
      formInline: {
        product_name: '',
        structure_1: '',
        status: '',
        start_date: '',
        end_date: '',
        date: '',
      },
      consume: [],
      size: 'small',
      detailDialogVisible: false,
      levell: [1, 2],
      selectName: '',
      organLabel: '',
      kc: 0,
      ruleForm: {
        "consumed_product_id": "",
        "apply_quantity": "",
        "apply_reason": "",
        syyt: '',
        syzs: '',
        bj: '',
        lyr: "",
        kc_id: '',
        kcmc: '',
        rs: ''
      },
      loading1: false,
      courseList: [],
      rowObj: {},
      rules: {
        consumed_product_id: [{ required: true, message: '请选择', trigger: 'change' }],
        apply_quantity: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: this.checkfloat, trigger: 'blur' },
        ],
        apply_reason: [{ required: true, message: '请输入', trigger: 'blur' }],
        syzs: [
          { required: true, message: '使用周数不能为空' },
          { type: 'number', message: '使用周数必须为数字值' },
        ],
        syyt: [{ required: true, message: '请选择', trigger: 'change' }],
        bj: [{ required: true, message: '请输入'}],
        lyr: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      action: '',
      downloadUrl: '',
      downloadName: '实训耗材采购申请模版.xlsx',
      btnTitle: '导入实训耗材采购申请数据',
      listArr: [],
      consumes: []
    };
  },
  created() {
    this.action = `${this.baseUrlt}api/device/purchase2/import`;
    this.downloadUrl = `api/device/purchase2/getTemplate`;
    this.$store.dispatch('getTarinMent');

    // this.$store.dispatch('getTermms');
  },
  computed: {
  },
  mounted() { },
  methods: {
    handleEditInit(row) {
      if (row.kc_id && JSON.stringify(this.courseList).indexOf(row.kc_id) == -1) {
        this.courseList.push({ id: row.kc_id, course_name: row.kcmc })
      }
      this.getConsumes()
      // this.getCourseList()
    },
    handleTargetChange(val) {
      const { training_name, training_no } = this.$until.getLabelNameNew({ arr: this.$store.state.trainRooms, id: val })
      this.ruleForm.apply_training_room_name = training_name;
      this.ruleForm.apply_training_room_number = training_no;
    },
    handleComsumeChange(e) {
      const item = this.$until.getLabelNameNew({ arr: this.consumes, id: e })
      this.kc = item.remainder_quantity ? item.remainder_quantity : 0
    },
    handleCourseChange(e) {
      // this.ruleForm.course_name = this.$until.getLabelName(this.courseList, 'id', 'course_name', e);
      // this.ruleForm.term = this.$until.getLabelName(this.courseList, 'id', 'xn', e) + ' ' + this.$until.getLabelName(this.courseList, 'id', 'term', e);
      const item = this.$until.getLabelNameNew({ arr: this.courseList, id: e })
      this.ruleForm.kcmc = item.course_name
    },
    handleUseChange(val) {
      if (val != '教学') {
        this.ruleForm.kc_id = ''
        this.ruleForm.kcmc = ''
        this.ruleForm.rs = ''
      }
    },
    async getCourseList(query) {
      // if (this.courseList && this.courseList.length) {
      //   return
      // }
      this.loading1 = true
      let res = await this.$api.query.getClassPlanList({ page: 1, size: 9999, apply_status: 'pass', course_name: query });
      this.loading1 = false
      if (res.code == 0 && res.data) {
        this.courseList = res.data.data;
      }
    },
    // handleChemicalChange(val) {
    //   const { unit } = this.$until.getLabelNameNew({ arr: this.consumes, id: val })
    //   this.ruleForm.unit = unit;
    // },
    // async detailMethod(row, type = "view") {
    //   let res = await this.$api.instance.interfaceServer(`api/chemical/purchase/detail/${row.id}`, 'get');
    //   if (res.code == 0 && res.data) {
    //     if (type == "view") {
    //       this.rowObj = res.data;
    //       this.detailDialogVisible = true;
    //     } else {
    //       this.handleEditNew(res.data)
    //     }
    //   }
    // },
    detailMethod(row, type = "view") {
      if (type == "view") {
        this.rowObj = row;
        this.detailDialogVisible = true;
      } else {
        this.handleEditNew(row, ['id'], () => {
          this.handleEditCallBackSetStruc({ major: 'apply_structure_2', dep: 'apply_structure_1', row: row })
        })
      }
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/consume/apply/delete/${params.id}`, 'DELETE', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/consume/apply/create', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/consume/apply/update/${params.id}`, 'put', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    getOrganList() {
      this.beforeGetOrgan({ limit: false, major: "apply_structure_2", dep: 'apply_structure_1' });
      // this.$store.dispatch('getTarinMent', { structure_1: this.ruleForm.apply_structure_1, structure_2: this.ruleForm.apply_structure_2});

    },
    handleQuery() {
      this.beforeQueryByKeyNew({ dep: 'structure_1' });
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getConsumes() {
      if (this.consumes && this.consumes.length) {
        return
      }
      let res = await this.$api.instance.interfaceServer('api/consume/query', 'post', { page: 1, size: 9999 });
      if (res.code == 0 && res.data) {
        this.consumes = res.data.data;
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      if (params.date && params.date.length > 0) {
        params.start_date = params.date[0];
        params.end_date = params.date[1];
        delete params.date;
      }
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/consume/apply/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
